import { Vector3 } from 'three';
import { Edge, Vertex, Face } from '@phi/jcore';
import { get_camera_look_vector } from './utility';

export default class EdgeProjectionData {
    direction: null | Vector3;
    edge_list: Edge[];
    vertex_list: Vertex[];
    offset: number;
    projection_type: '' | 'plane' | 'face' | 'edge';
    object_orientation_direction: null | Vector3;
    used_view_direction: boolean;
    flipped_view_direction: boolean;
    projection_faces: Face[];

    constructor() {
        this.direction = null;
        this.edge_list = [];
        this.vertex_list = [];
        this.offset = 0;
        this.projection_type = '';
        this.object_orientation_direction = null;
        this.used_view_direction = false;
        this.flipped_view_direction = false;
        this.projection_faces = [];
    }

    set_direction(dir: Vector3) {
        this.direction = new Vector3();
        this.direction.copy(dir);
        if (this.object_orientation_direction != null) {
            // Check whether we need to flip the direction of the normal.
            const look_vector = get_camera_look_vector(uid_camera).normalize();
            const d = this.object_orientation_direction.dot(this.direction);
            if (d < 0)
                global_edge_projection_data.direction!.multiplyScalar(-1);
        }
    }
}
